import { FC, useLayoutEffect } from 'react';
import * as am5 from '@amcharts/amcharts5';
import * as am5hierarchy from "@amcharts/amcharts5/hierarchy";
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';
import * as types from '@models/types';
import Cookies from 'js-cookie'
import './Charts.scss';

type TreemapChartProps = {
    name: string,
    data: types.SectorAndOccupationParentObjTypes[],
    handleClick?: (a: any) => void
};

const TreemapChart: FC<TreemapChartProps> = ({ name, data, handleClick }) => {
    useLayoutEffect(() => {
        am5.ready(function () {
            am5.addLicense('AM5M326788873');
            am5.addLicense('AM5C326788873')

            const root = am5.Root.new(`${name}-treemapChart`);
            const defaultTheme = am5.Theme.new(root);
            root.setThemes([am5themes_Animated.new(root), defaultTheme]);

            defaultTheme.rule("ColorSet").set("colors", [
                am5.color(0x003b5c),
                am5.color(0x035684),
                am5.color(0x036eaa),
                am5.color(0x0486cf),
                am5.color(0x00293f),
                am5.color(0x118ab2),
                am5.color(0x253948),
                am5.color(0x385870),
                am5.color(0x487292),
                am5.color(0x06d6a0),
                am5.color(0x5686aa),
                am5.color(0x073b4c),
                am5.color(0x71afde),
            ]);

            // Set tooltips for Parent level
            defaultTheme.rule("RoundedRectangle", ["hierarchy", "node", "shape", "depth1"]).setAll({
                tooltipHTML: "<div style=\"text-align: center; color: white;\">{name}</br>Number of job posts: {parentValue}</br>Share of total: {parentPercentage}%</div>",
            });

            // Set tooltips for Children level
            defaultTheme.rule("RoundedRectangle", ["hierarchy", "node", "shape", "depth2"]).setAll({
                tooltipHTML: "<div style=\"text-align: center; color: white;\">{name}</br>Number of job posts: {value}</br>Share of total: {percentage}%</div>",
            });


            if (Cookies.get('darkMode') === "true") {

            } else {

            }
            const container = root.container.children.push(
                am5.Container.new(root, {
                    width: am5.percent(100),
                    height: am5.percent(100),
                    layout: root.verticalLayout
                })
            );

            let series = container.children.push(
                am5hierarchy.Treemap.new(root, {
                    sort: "descending",
                    downDepth: 1,
                    upDepth: 0,
                    initialDepth: 1,
                    valueField: "value",
                    categoryField: "name",
                    childDataField: "children",
                    layoutAlgorithm: "binary",
                    nodePaddingOuter: 5,
                    nodePaddingInner: 1,
                    minWidth: 200,
                    interactive: true
                })
            );

            // Calculating parent totals (values and percentages)
            var treeData = [];
            for (var i = 0; i < data.length; i++) {
                var parentValue = 0;
                var parentPercentage = 0;
                for (var j = 0; j < data[i].children.length; j++) {
                    parentValue += data[i].children[j].value;
                    parentPercentage += Number(data[i].children[j].percentage);
                }
                treeData.push({ name: data[i].name, parentValue: parentValue, parentPercentage: parentPercentage, children: data[i].children });
            }
            // Setting data and selecting the first level in the tree
            series.data.setAll([{
                name: (name.includes("Sector") ? "Sector(s)" : "Occupation(s)"),
                children: treeData
            }]);
            series.set("selectedDataItem", series.dataItems[0]);

            series.labels.template.setAll({
                fontSize: Number(Cookies.get('globalFontSize'))*0.71, //10px,
                textAlign: "center",
                oversizedBehavior: "wrap"
            });

            // Loop through all dataItems and check if needed to remove the label (name) of the item because its value is smaller than 200
            if (series.dataItems.length) {
                const dataItems = series.dataItems[0].get("children");
                for (let i = 0; i < dataItems.length; i++) {
                    const dataItemChildren = dataItems[i].get("children");
                    var dataItemChildrenTotal = 0;

                    for (let j = 0; j < dataItemChildren.length; j++) {
                        if (dataItemChildren[j].get("value") < 200) {
                            dataItemChildren[j].get("label").set("forceHidden", true)
                        }
                        dataItemChildrenTotal += dataItemChildren[j].get("value");

                        if (handleClick) {
                            dataItemChildren[j]._settings.node.events.on("click", function (ev: any) {
                                const dataValue = ev?.target?.dataItem?.dataContext.name;
                                var selectedSquare = {};
                                if (name === "Sector")
                                    selectedSquare = { "sector": dataValue };
                                if (name === "Occupation")
                                    selectedSquare = { "occupation": dataValue };
                                handleClick(selectedSquare);
                            });
                        }
                    }

                    if (dataItemChildrenTotal < 200) {
                        dataItems[i].get("label").set("forceHidden", true)
                    }
                }
            }


            // Add breadcrumbs
            container.children.unshift(
                am5hierarchy.BreadcrumbBar.new(root, {
                    series: series
                })
            );
        });
    }, []);// eslint-disable-line react-hooks/exhaustive-deps

    return <div id={`${name}-treemapChart`} className="chart-container" style={{ height: 500 }} />;
};

export default TreemapChart;
